import React from 'react';
import Lottie from 'react-lottie';
import animationData from '../../assets/icons/augustsays/Beep_pending.json';
import talkData from '../../assets/icons/augustsays/Beep_talking.json';
import boopAnimationData from '../../assets/icons/augustsays/Boop_pending.json';
import boopTalkData from '../../assets/icons/augustsays/Boop_talking.json';

export function BeepAnimate() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
  try {
    return (
      <Lottie options={defaultOptions} style={{ width: 55, height: 55 }} />
    );
  } catch {
    // Fallback if rendering fails for any reason
    return (
      <div style={{ display: 'inline-flex', gap: 6 }} aria-hidden>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
      </div>
    );
  }
}

export function BoopTalk() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: boopTalkData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
  try {
    return (
      <Lottie options={defaultOptions} style={{ width: 55, height: 55 }} />
    );
  } catch {
    // Fallback if rendering fails for any reason
    return (
      <div style={{ display: 'inline-flex', gap: 6 }} aria-hidden>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
      </div>
    );
  }
}

export function BoopAnimate() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: boopAnimationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
  try {
    return (
      <Lottie options={defaultOptions} style={{ width: 55, height: 55 }} />
    );
  } catch {
    // Fallback if rendering fails for any reason
    return (
      <div style={{ display: 'inline-flex', gap: 6 }} aria-hidden>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
      </div>
    );
  }
}

export function BeepTalk() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: talkData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
  try {
    return (
      <Lottie options={defaultOptions} style={{ width: 55, height: 55 }} />
    );
  } catch {
    // Fallback if rendering fails for any reason
    return (
      <div style={{ display: 'inline-flex', gap: 6 }} aria-hidden>
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
        <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#6b7280' }} />
      </div>
    );
  }
}